// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-item-box .el-input__inner{font-size:12px;padding:0 8px}", ""]);
// Exports
module.exports = exports;
